<template>
    <div class="form-group">
        <label :for="field" v-if="label">{{ label }}</label>
        <textarea :disabled="disabled"
                  :id="field"
                  :placeholder="placeholder"
                  class="form-control"
                  :class="{
                     'is-invalid': errors && errors.has(field)
                 }"
                  :maxlength="max"
                  :rows="rows"
                  :value="value"
                  @input="$emit('input', $event.target.value)"
                  @change="$emit('change', $event.target.value)"
                  @keydown.self.enter.exact="$emit('submit', $event.target.value)"
        >
        </textarea>
        <slot></slot>
        <small v-if="max" class="form-text text-muted">
            {{ value ? value.length : 0 }}/{{ max }}
        </small>
        <AppError v-if="errors" :errors="errors" :field="field"/>
    </div>
</template>

<script>
import AppError from './AppError';

export default {
  components: {
    AppError,
  },
  props: ['errors', 'label', 'value', 'field', 'max', 'disabled', 'placeholder', 'rows'],
};
</script>
